/**
  DO NOT EDIT THIS FILE MANUALLY
  Generated by `Opus::Mkt::Tools::GenerateReactData`
  If this file is out-of-sync or causing builds to fail, try running `scripts/bin/remote-script ./mkt/Tools/generate_react_data.rb`
*/

export const Countries = {
  US: {code: 'US', defaultCurrency: 'usd'},
  AE: {code: 'AE', defaultCurrency: 'aed'},
  AT: {code: 'AT', defaultCurrency: 'eur'},
  AU: {code: 'AU', defaultCurrency: 'aud'},
  BE: {code: 'BE', defaultCurrency: 'eur'},
  BG: {code: 'BG', defaultCurrency: 'eur'},
  BR: {code: 'BR', defaultCurrency: 'brl'},
  CA: {code: 'CA', defaultCurrency: 'cad'},
  CH: {code: 'CH', defaultCurrency: 'chf'},
  CY: {code: 'CY', defaultCurrency: 'eur'},
  CZ: {code: 'CZ', defaultCurrency: 'czk'},
  DE: {code: 'DE', defaultCurrency: 'eur'},
  DK: {code: 'DK', defaultCurrency: 'dkk'},
  EE: {code: 'EE', defaultCurrency: 'eur'},
  ES: {code: 'ES', defaultCurrency: 'eur'},
  FI: {code: 'FI', defaultCurrency: 'eur'},
  FR: {code: 'FR', defaultCurrency: 'eur'},
  GB: {code: 'GB', defaultCurrency: 'gbp'},
  GI: {code: 'GI', defaultCurrency: 'gbp'},
  GR: {code: 'GR', defaultCurrency: 'eur'},
  HK: {code: 'HK', defaultCurrency: 'hkd'},
  HR: {code: 'HR', defaultCurrency: 'eur'},
  HU: {code: 'HU', defaultCurrency: 'huf'},
  IE: {code: 'IE', defaultCurrency: 'eur'},
  IN: {code: 'IN', defaultCurrency: 'inr'},
  IT: {code: 'IT', defaultCurrency: 'eur'},
  JP: {code: 'JP', defaultCurrency: 'jpy'},
  LI: {code: 'LI', defaultCurrency: 'chf'},
  LT: {code: 'LT', defaultCurrency: 'eur'},
  LU: {code: 'LU', defaultCurrency: 'eur'},
  LV: {code: 'LV', defaultCurrency: 'eur'},
  MY: {code: 'MY', defaultCurrency: 'myr'},
  MT: {code: 'MT', defaultCurrency: 'eur'},
  MX: {code: 'MX', defaultCurrency: 'mxn'},
  NL: {code: 'NL', defaultCurrency: 'eur'},
  NO: {code: 'NO', defaultCurrency: 'nok'},
  NZ: {code: 'NZ', defaultCurrency: 'nzd'},
  PL: {code: 'PL', defaultCurrency: 'pln'},
  PT: {code: 'PT', defaultCurrency: 'eur'},
  RO: {code: 'RO', defaultCurrency: 'ron'},
  SE: {code: 'SE', defaultCurrency: 'sek'},
  SG: {code: 'SG', defaultCurrency: 'sgd'},
  SI: {code: 'SI', defaultCurrency: 'eur'},
  SK: {code: 'SK', defaultCurrency: 'eur'},
  TH: {code: 'TH', defaultCurrency: 'thb'},
} as const;
